.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

.count {
  font-weight: normal;
  color: var(--tuna-content-secondary);
}

.caption {
  margin: 0;
  color: var(--tuna-content-secondary);
}

/* Sentence-case ghost button, per the spec; the Button primitive defaults to uppercase. */
.toggle {
  align-self: flex-start;
  padding-inline: var(--tuna-spacing-1);
  text-transform: none;
  color: var(--tuna-content-secondary);
}
